const IsBlankItem = (x) => x == '' || x == ' ' || x == '\n' || x == '\t';
export class BulkInsertController {
    static $inject = ['$scope', 'close', 'questions', '$translate'];
    constructor($scope, close, questions, $translate) {
        'ngInject';
        this.$scope = $scope;
        this.close = close;
        this.arrayQuestions = questions;
        this._$translate = $translate;
    }
    hasItemInList(list1, list2) {
        let i, j;
        const set = new Set();
        for (j = 0; j < list2.length; j++) {
            if (!set.has(list2[j])) {
                set.add(list2[j]);
            }
            else {
                return true;
            }
        }
        for (i = 0; i < list1.length; i++) {
            for (j = 0; j < list2.length; j++) {
                if (list2[j] == list1[i]) {
                    return true;
                }
            }
        }
    }
    closeModal() {
        this.close(this.arrayQuestions);
    }
    async insert() {
        const errorMsg62 = await this._$translate('utils.errorMsg.62');
        if (this.bulkQuestionsTxt && this.bulkQuestionsTxt !== undefined) {
            const bulkArray = this.bulkQuestionsTxt
                .split('\n')
                .filter((x) => !IsBlankItem(x))
                .map((x) => x.trim());
            if (this.hasItemInList(this.arrayQuestions, bulkArray)) {
                this.error = errorMsg62;
                return;
            }
            if (this.arrayQuestions.length == 0) {
                this.arrayQuestions = bulkArray;
            }
            else {
                this.arrayQuestions = this.arrayQuestions.concat(bulkArray);
            }
        }
        this.close(this.arrayQuestions);
    }
}
BulkInsertController.$inject = ['$scope', 'close', 'questions', '$translate'];
